
import { Component, OnInit, Inject } from '@angular/core';
import { identifierModuleUrl } from '@angular/compiler';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';
import { DgHubClientService, SettingsRequest, Settings } from 'src/app/Services/dg-hub-client.service';
import { DrawingService } from 'src/app/Services/DrawingService';
@Component({
  selector: 'app-settings-dialog',
  templateUrl: './priceLIneSettings.component.html',
  styleUrls: ['./priceLIneSettings.component.css']
})
export class PriceLineSettingsDialogComponent implements OnInit {

  private _isSignal: boolean = false;
  public get isSignal(): boolean {
    return this._isSignal;
  }
  public set isSignal(value: boolean) {
    this._isSignal = value;
  }

  public isEdit = false;

  constructor(
    public dialogRef: MatDialogRef<PriceLineSettingsDialogComponent>,
    private fb: FormBuilder,
    public dgCLientService:DgHubClientService,
    public drawingService:DrawingService,
    @Inject(MAT_DIALOG_DATA) public data: any
    ) {

      if(this.data)
      {
        this.isEdit = true;
        this.color = this.data.color;
        this.isSignal = this.data.isSignal
      }

  }


  ngOnInit() {

  }

  onConfirm(): void {
    // Close the dialog, return true

    this.dialogRef.close(true);
  }
  private _color: string = "#ffffff";
  public get color(): string {
    return this._color;
  }
  public set color(value: string) {
    this._color = value;
  }
  colorUpdate(e)
  {
   // //console.log(e.currentTarget.value);
   this.color = e.currentTarget.value;
  }
  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }
}
